import { useApi } from "../../../swr/useApi";
import { productColorsService } from "../../api_client";
import type { ProductAttributeValueDto } from "../../../api";

export function useProductColors() {
  return useApi<ProductAttributeValueDto[]>(
    "product-colors",
    async () => {
      return await productColorsService.getProductColors();
    },
  );
}
